export default __webpack_public_path__ + "static/mailbox-77d264861064c359bcdf5e9ee0f165fc.png";